export default __webpack_public_path__ + "static/media/SpainFlag.304e3e7d.png";